<template>
  <div class="simplecard">
    <div class="simplecard-content has-text-centered">
      <h6 class="simplecard-title">
        <slot name="title" />
      </h6>
      <slot name="content" />
    </div>
    <div class="simplecard-footer">
      <slot name="footer" />
    </div>
  </div>
</template>

<script>
export default {
  name: 'SimpleCard'
}
</script>

<style lang="scss" scoped>
@import '~@/assets/stylesheets/styleguide';
.simplecard {
  min-width: 16.875rem;
  //max-width: 16.875rem;
  width: 100%;
  //height: 7.6875rem;
  border: 0.0625rem solid $neutral-color-4;
  border-color: var(--neutral-color-4);
  border-radius: 0.25rem;
  box-shadow: none;

  background-color: var(--bg-color-card);

  i {
    padding-bottom: 0.3125rem;
  }

  .simplecard-content {
    padding: 0.75rem;
  }

  .simplecard-title {
    display: inline-grid;

    color: var(--light-blue);
    font-size: 1.25rem;
    font-weight: $font-semi-bold;

    line-height: 1.5rem;
  }

  .simplecard-footer {
    width: 100%;
    text-align: center;
  }

  p {
    font-weight: $font-normal;
    font-size: 0.875rem;
    line-height: 1rem;
    padding-top: 0.9375rem;
  }
}

.simplecard:hover {
  // border-bottom: 0.2rem solid $light-blue;
  cursor: pointer;
}

@media (max-width: 64rem) {
  .simplecard {
    max-width: 100%;
  }
}
</style>
